import React from 'react';

interface LoadingProps {
  fullScreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({
  fullScreen = false,
  size = 'md',
  text = 'Carregando...'
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const Spinner = () => (
    <div className="flex flex-col items-center gap-3">
      <div className={`${sizeClasses[size]} animate-spin`}>
        <div className="h-full w-full rounded-full border-4 border-gray-200 dark:border-gray-700
          border-t-indigo-600 dark:border-t-indigo-400" />
      </div>
      {text && (
        <p className={`${textSizes[size]} text-gray-600 dark:text-gray-300`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center 
        bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm"
      >
        <Spinner />
      </div>
    );
  }

  return <Spinner />;
};

export default Loading; 